﻿// CURRENTLY NOT IN USE
// NOTE: PLEASE UPDATE ALL REFERENCES OF STAGE TO OPERATIONS INCLUDING THE COMPONENT NAME
// IF THIS COMPONENT GETS USED THE ABOVE MUST BE DONE

import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import {
  selectCycles,
  selectCurrentOperationId,
  selectOperationsStatus,
  fetchOperations,
  selectCurrentCycleId,
} from "@/features/operations/operationsSlice";
import "./StageCheckbox.css";

const StageCheckbox = ({ selectedStages, onCheckboxChange }) => {
  const dispatch = useDispatch();
  const [checkedValues, setCheckedValues] = useState([]);
  const stagesPerColumn = 6;
  var cycles = useSelector(selectCycles);
  var currentCycleId = useSelector(selectCurrentCycleId);
  var operationsStatus = useSelector(selectOperationsStatus);
  var operationList = cycles.find(
    (x) => x.cycleId == currentCycleId
  ).operations;

  var columnCount = Math.min(
    Math.ceil(operationList.length / stagesPerColumn),
    3
  );
  var rowCount = Math.max(
    Math.ceil(operationList.length / columnCount),
    stagesPerColumn
  );

  const handleCheckboxChange = (stageName) => {
    let updatedValues;
    if (selectedStages) {
      // Pass the updated values to the parent component
      onCheckboxChange([stageName]);
    } else {
      updatedValues = [...checkedValues];
      if (updatedValues.includes(stageName)) {
        updatedValues.splice(updatedValues.indexOf(stageName), 1);
      } else {
        updatedValues.push(stageName);
      }
      setCheckedValues(updatedValues);

      // Pass the updated values to the parent component
      onCheckboxChange(updatedValues);
    }
  };

  useEffect(() => {
    if (operationsStatus !== undefined && !operationsStatus.includes("load")) {
      dispatch(fetchOperations());
    }
  }, []);

  let width = Math.max(columnCount, 2) * 300;
  return (
    <Box>
      <Container style={{ width: width, marginLeft: "unset" }}>
        <Box className="stages-heading-container" style={{ width: width }}>
          <Typography variant="body1" className="stages-heading">
            Stages
          </Typography>
        </Box>
        <Grid
          container
          direction="column"
          columns={columnCount}
          style={{ width: width, height: rowCount * 75 }}
        >
          {operationList != null &&
            operationList.map((stage, i) => (
              <Grid
                item
                key={i}
                style={{
                  height: 75,
                  width: (1 / columnCount) * 100 + "%",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        selectedStages && selectedStages.includes(stage.stageId)
                      }
                      onChange={() => handleCheckboxChange(stage.stageId)}
                    />
                  }
                  label={<Typography variant="body2">{stage.name}</Typography>}
                  style={{ height: 75, margin: 0, paddingLeft: 8 }}
                />
                {!((i + 1) % stagesPerColumn === 0) && <Divider />}
              </Grid>
            ))}
        </Grid>
        <Box className="stages-footer-container" style={{ width: width }} />
      </Container>
    </Box>
  );
};

export default StageCheckbox;
